import React, { useContext, useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import FormControl from "react-bootstrap/esm/FormControl";
import InputGroup from "react-bootstrap/esm/InputGroup";
import Modal from "react-bootstrap/esm/Modal";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import CategoryTouchList from "../components/CategoryTouchList";
import CustomerOrder from "../components/CustomerOrder";
import MessageBox from "../components/MessageBox";
import MyKeyboard from "../components/MyKeyboard";
import NumberPad from "../components/NumberPad";
import OrderTouchNavigation from "../components/OrderTouchNavigation";
import ProductsListTouch from "../components/ProductsListTouch";
import TableButtonSmall from "../components/TableButtonSmall";
import TableExchange from "../components/TableExchange";
import useAxios from "../hooks/useAxios";
import useCompartments from "../hooks/useCompartments";
import useProductsAndCategories from "../hooks/useProductsAndCategories";
import CartScreenTouch from "./CartScreenTouch";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "STATIC_FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default function OrderTouchScreen() {
  const axios = useAxios();
  const descriptionRef = useRef(null);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    userInfo,
    carts,
    mostUsedProducts,
    products,
    categories,
    allCategories,
  } = state;
  const compartments = state.compartments || [];
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const rootCategory = sp.get("rootCategory") || "";
  const showCustomerOrdersParam = sp.get("customer") || false;
  const navigate = useNavigate();
  const [isMostUsedProductsSelected, setIsMostUsedProductsSelected] =
    useState(true);
  const [tableTemp, setTableTemp] = useState(0);
  const [showAddCard, setShowAddCard] = useState(false);
  const [showNumberPadForProductsList, setShowNumberPadForProductsList] =
    useState(false);
  const [queryByName, setQueryByName] = useState("");
  const [loadingUpdateNewItem, setLoadingUpdateNewItem] = useState(false);
  const [changeWithTableNum, setChangeWithTableNum] = useState(0);
  const [changeThisTableNum, setChangeThisTableNum] = useState(0);
  const [description, setDescription] = useState("");
  const [isSaveProduct, setIsSaveProduct] = useState(false);
  const [showNumberPad, setShowNumberPad] = useState(false);
  const [numberPadNumber, setNumberPadNumber] = useState(null);
  const [categoryEditorOperationOk, setCategoryEditorOperationOk] =
    useState(false);

  const [categoryOrderingChanged, setCategoryOrderingChanged] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [showExchangeTable, setShowExchangeTable] = useState(false);
  const [showEnterDescription, setShowEnterDescription] = useState(false);

  const [features, setFeatures] = useState([]);
  const [feature, setFeature] = useState("");
  const [product, setProduct] = useState("");

  const [alertColor, setAlertColor] = useState(false);
  const [cartsOrdered, setCartsOrdered] = useState([]);
  const [showCustomerOrders, setShowCustomerOrders] = useState(false);

  const [selectedCompartment, setSelectedCompartment] = useState(null);
  const [tableCompartment, setTableCompartment] = useState(null);
  const [mostUsedProductsFiltered, setMostUsedProductsFiltered] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [tableCompartmentProducts, setTableCompartmentProducts] = useState([]);
  const [categories2, setCategories2] = useState([]);

  useCompartments();
  const [, , setLoadProducts, setLoadCategories] = useProductsAndCategories();

  const setNumberPadNumberSelectionHandler = () => {
    if (numberPadNumber) {
      setTableTemp(numberPadNumber);
      ctxDispatch({
        type: "SELECT_TABLE",
        payload: numberPadNumber,
      });

      var elem = document.getElementById("tablePanel");
      elem.scrollTop =
        document.getElementById("tableButton" + numberPadNumber).offsetTop -
        200;
    }
    setShowNumberPad(false);
  };

  const setNumberPadNumberSelectionHandlerForProductList = (numberPad) => {
    let founds = products.filter((p) => p.no === Number(numberPad));

    founds =
      tableCompartment &&
      tableCompartment.categories &&
      tableCompartment.categories.length > 0 &&
      tableCompartmentProducts.length > 0
        ? founds.filter((m) => tableCompartmentProducts.includes(m._id))
        : founds;

    if (founds.length > 0) {
      setFeatures(founds[0].features);
      setProduct(founds[0]);

      setShowAddCard(true);
      setShowNumberPadForProductsList(false);
    } else {
      setShowNumberPadForProductsList(false);
      toast.warning("Ürün bulunamadı!");
    }
  };

  const handleDescriptionChange = async (tableOrder) => {
    try {
      const { data } = carts[changeThisTableNum - 1].tableCode
        ? { data: carts[changeThisTableNum - 1] }
        : await axios.get(`/api/customer?tableNum=${changeThisTableNum}`);

      await axios.put(`/api/customer/orders/${data.tableCode}`, {
        description,
      });
      ctxDispatch({
        type: "CART_CHANGE_DESCRIPTION",
        payload: {
          description,
          tableNum: changeThisTableNum,
        },
      });
      setShowEnterDescription(false);
    } catch {
      toast.error("Masa adı değiştirilemedi!");
    }
  };

  useEffect(() => {
    const founds = compartments
      .filter((c) => c.status)
      .filter((c) => tableTemp >= c.startNum && tableTemp <= c.endNum);
    if (founds.length > 0) {
      setTableCompartment(founds[0]);
      if (founds[0].categories && founds[0].categories.length > 0) {
        setTableCompartmentProducts(
          founds[0].categories
            .flatMap((c) => c.products)
            .filter((value, index, array) => array.indexOf(value) === index)
        );
      }
    }
  }, [tableTemp, userInfo]);

  useEffect(() => {
    if (showCustomerOrdersParam) {
      setShowCustomerOrders(true);
      setTableTemp(0);
      ctxDispatch({ type: "SELECT_TABLE", payload: 0 });
    }
  }, [showCustomerOrdersParam]);

  useEffect(() => {
    const cartsOrders = carts.filter(
      (cart) =>
        cart && cart.cartItems.length > 0 && !cart.delivered && cart.alert
    );
    setCartsOrdered(cartsOrders);
  }, [carts, userInfo]);

  const resetToHead = () => {
    setFeature("");
    setFeatures([]);
    setProduct("");
    setQueryByName("");
  };

  /*useEffect(() => {
    const fetchCustomerOrders = async () => {
      if (!userInfo) {
        return;
      }
      try {
        const { data } = await axios.get(
          `/api/customer/orders?homeOrder=true&updatedAt=${
            localStorage.getItem('updatedAt') || ''
          }`
        );

        if (data && data.orders && data.orders.length > 0) {
          let maxUpdatedAt = localStorage.getItem('updatedAt')
            ? new Date(localStorage.getItem('updatedAt'))
            : null;
          data.orders.forEach((o) => {
            if (!maxUpdatedAt || new Date(o.updatedAt) > maxUpdatedAt) {
              maxUpdatedAt = new Date(o.updatedAt);
            }
          });
          localStorage.setItem('updatedAt', maxUpdatedAt.toISOString());

          if (data.orders.length === 1 && data.orders[0].tableNum) {
            const tableOrder = data.orders[0];
            const order = carts[tableOrder.tableNum - 1];
            if (order.cartItems.length === tableOrder.orderItems.length) {
              const diff = tableOrder.orderItems.filter((item, index) => {
                if (
                  order.description !== tableOrder.description ||
                  item.itemCode !== order.cartItems[index].itemCode ||
                  item.customerName !== order.cartItems[index].customerName ||
                  item.quantity !== order.cartItems[index].quantity
                ) {
                  return true;
                }
                return false;
              });
              if (diff.length === 0) {
                return;
              }
            }
          }
          data.orders.forEach((tableOrder) => {
            tableOrder.orderItems.forEach((item) => {
              ctxDispatch({
                type: 'CUSTOMER_CART_ADD_ITEM',
                payload: {
                  ...item.product,
                  menuName: item.name,
                  price: item.price || item.product.price, // price ve menuName menu tanimindan gelebilir, product tarafindan eziliyor yukardaki spreadde
                  quantity: item.quantity,
                  tableNum: tableOrder.tableNum,
                  createdAt: tableOrder.createdAt,
                  itemCode: item.itemCode,
                  relativeItem: item.relativeItem,
                  mainPrice: item.mainPrice,
                  tableCode: tableOrder.tableCode,
                  feature: item.feature,
                  clientCode: item.clientCode || tableOrder.clientCode,
                  customerName: item.customerName || tableOrder.description,
                  address: item.address,
                  answers: item.answers,
                  alert: item.alert,
                },
              });
            });
            if (tableOrder.orderItems.length > 0 && tableOrder.description) {
              ctxDispatch({
                type: 'CART_CUSTOMER_CHANGE_DESCRIPTION',
                payload: {
                  tableNum: tableOrder.tableNum,
                  clientCode: tableOrder.clientCode,
                  user: tableOrder.user,
                  tableCode: tableOrder.tableCode,
                  customerName: tableOrder.description,
                  alert: tableOrder.alert,
                },
              });
            }
          });

          const cartsNotEmpty = carts.filter((c, i) => c.cartItems.length > 0);

          if (cartsNotEmpty && cartsNotEmpty.length > 0) {
            cartsNotEmpty.forEach((c) => {
              data.orders.forEach((o) => {
                if (o.tableNum === c.tableNum) {
                  ctxDispatch({
                    type: 'CUSTOMER_CART_REMOVE_ITEMS',
                    payload: {
                      tableNum: c.tableNum,
                      tableCode: o.tableCode,
                      itemCodes: o.orderItems.map((o) => o.itemCode),
                    },
                  });
                }
              });
            });
          }
        }
      } catch (err) {}
    };

    const interval = setInterval(() => {
      if (!document.hidden) fetchCustomerOrders();
    }, 1000 * 2);

    return () => clearInterval(interval);
  }, [carts, userInfo]);*/

  useEffect(() => {
    setAlertColor(false);
    cartsOrdered.some((cart) => {
      if (
        cart.cartItems.filter((item) => item.alert && !item.delivered).length >
        0
      ) {
        setAlertColor((v) => !v);
        return true;
      }
      return false;
    });
  }, [cartsOrdered, userInfo]);

  useEffect(() => {
    cartsOrdered.forEach((c) => {
      c.cartItems.forEach((item) => {
        if (!item.delivered && item.alert && !item.alertPlayed) {
          var audio = new Audio("/ding.mp3");
          audio.play();
          ctxDispatch({
            type: "CARTITEM_SET_ALERT_PLAYED",
            payload: {
              tableNum: c.tableNum,
              itemCode: item.itemCode,
            },
          });
        }
      });
    });
  }, [cartsOrdered, userInfo]);

  useEffect(() => {
    setFilteredCategories(
      tableCompartment &&
        tableCompartment.categories &&
        tableCompartment.categories.length > 0
        ? tableCompartment.categories
        : categories
    );

    if (queryByName) {
      let queryProducts = isNaN(queryByName)
        ? products.filter((p) =>
            p.name.toLowerCase().includes(queryByName.toLowerCase())
          )
        : products.filter((p) => p.no === Number(queryByName));

      queryProducts =
        tableCompartment &&
        tableCompartment.categories &&
        tableCompartment.categories.length > 0 &&
        tableCompartmentProducts.length > 0
          ? queryProducts.filter((m) =>
              tableCompartmentProducts.includes(m._id)
            )
          : queryProducts;

      setFilteredProducts(queryProducts);
    } else {
      if (rootCategory) {
        const rootCategories = allCategories.filter(
          (c) => c._id === rootCategory
        )[0].categories;
        const rootProducts = allCategories.filter(
          (c) => c._id === rootCategory
        )[0].products;
        if (rootCategories.length > 0) {
          setCategories2(rootCategories);
          //setFilteredProducts([]);
        } else if (rootProducts.length > 0) {
          setFilteredProducts(rootProducts);
          //setFilteredCategories([]);
          setCategories2([]);
        }
      } else {
        if (!mostUsedProducts || mostUsedProducts.length === 0) {
          setCategories2(
            tableCompartment &&
              tableCompartment.categories &&
              tableCompartment.categories.length > 0
              ? tableCompartment.categories
              : categories
          );
          //setFilteredProducts([]);
        } else {
          setFilteredProducts(mostUsedProductsFiltered);
          //setFilteredCategories([]);
        }
      }
    }
  }, [
    mostUsedProductsFiltered,
    queryByName,
    products,
    categories,
    tableCompartment,
    tableCompartmentProducts,
    rootCategory,
    mostUsedProducts,
    allCategories,
    userInfo,
  ]);

  useEffect(() => {
    if (categoryOrderingChanged || categoryEditorOperationOk || isSaveProduct) {
      setLoadCategories(true);
      setLoadProducts(true);
    }
  }, [
    categoryOrderingChanged,
    categoryEditorOperationOk,
    isSaveProduct,
    useEffect,
  ]);

  useEffect(() => {
    const founds = compartments
      .filter((c) => c.status)
      .filter((c) => tableTemp >= c.startNum && tableTemp <= c.endNum);
    if (founds.length > 0) {
      setTableCompartment(founds[0]);
      if (founds[0].categories && founds[0].categories.length > 0) {
        setTableCompartmentProducts(
          founds[0].categories
            .flatMap((c) => c.products)
            .filter((value, index, array) => array.indexOf(value) === index)
        );
      }
    }
  }, [tableTemp, userInfo]);

  useEffect(() => {
    const mostUsedFiltered =
      tableCompartment &&
      tableCompartment.categories &&
      tableCompartment.categories.length > 0 &&
      tableCompartmentProducts.length > 0
        ? mostUsedProducts.filter((m) =>
            tableCompartmentProducts.includes(m._id)
          )
        : mostUsedProducts;

    setMostUsedProductsFiltered(mostUsedFiltered || []);
  }, [tableCompartment, tableCompartmentProducts, mostUsedProducts, userInfo]);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <Helmet>
        <title>Siparisler</title>
      </Helmet>

      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: "12.5%",
          right: "125%",
          zIndex: isVisible ? "999" : "-1",
          width: "75%",
        }}
      >
        <MyKeyboard
          setInput={setQueryByName}
          input={queryByName}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          found={products?.length > 0}
        ></MyKeyboard>
      </div>

      <Button
        variant="warning"
        size="sm"
        style={{
          position: "absolute",
          bottom: "-10px",
          left: "-30px",
          zIndex: "998",
          aspectRatio: "1/1",
          minWidth: "40px",
        }}
        onClick={(e) => {
          if (showCustomerOrders) {
            setTableTemp(0);
            ctxDispatch({ type: "SELECT_TABLE", payload: 0 });
          }
          navigate("/");
        }}
      >
        <div className="small-font text-bold">WEB</div>
        <i className="fas fa-long-arrow-alt-left"></i>
      </Button>

      <div style={{ marginTop: "1rem" }}>
        <div className="d-flex">
          {showCustomerOrders ? (
            <div
              className="bg-dark border border-secondary rounded p-1 bs-table-bg heightOfPanelTouch"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "460px",
                flexShrink: "3",
              }}
            >
              <OrderTouchNavigation
                setNumberPadNumber={setNumberPadNumber}
                setSelectedCompartment={setSelectedCompartment}
                setShowCustomerOrders={setShowCustomerOrders}
                setShowNumberPad={setShowNumberPad}
                tableCompartmentProducts={tableCompartmentProducts}
                setTableTemp={setTableTemp}
                ctxDispatch={ctxDispatch}
                alertColor={alertColor}
                isCustomerOrder={showCustomerOrders}
              />
              {cartsOrdered.length === 0 ? (
                <div className="m-1">
                  <MessageBox>Müşteri siparişi yok!</MessageBox>
                </div>
              ) : (
                cartsOrdered
                  .filter((c) => c.cartItems.length > 0)
                  .map((c) => (
                    <div key={c.tableNum}>
                      <CustomerOrder
                        cartItems={c.cartItems}
                        cart={c}
                        isTabletOrMobile={isTabletOrMobile}
                        tableNum={c.tableNum}
                        tableTemp={tableTemp}
                        setTableTemp={setTableTemp}
                        ctxDispatch={ctxDispatch}
                        alertColor={alertColor}
                      ></CustomerOrder>
                    </div>
                  ))
              )}
            </div>
          ) : (
            <div
              className="bg-dark border border-secondary rounded p-1 bs-table-bg heightOfPanelTouchNoOverflow"
              style={{
                maxWidth: "460px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <OrderTouchNavigation
                setNumberPadNumber={setNumberPadNumber}
                setSelectedCompartment={setSelectedCompartment}
                setShowCustomerOrders={setShowCustomerOrders}
                setShowNumberPad={setShowNumberPad}
                tableCompartmentProducts={tableCompartmentProducts}
                setTableTemp={setTableTemp}
                ctxDispatch={ctxDispatch}
                alertColor={alertColor}
                isCustomerOrder={showCustomerOrders}
              />
              {compartments && compartments.length > 1 && (
                <div
                  style={{ width: "100%" }}
                  className="d-grid ps-1 pe-1 mb-1"
                >
                  <div className="btn-group" role="group">
                    <Button
                      size="lg"
                      type="button"
                      variant={
                        !selectedCompartment ? "primary" : "outline-secondary"
                      }
                      onClick={() => {
                        setSelectedCompartment(null);
                      }}
                    >
                      Tümü
                    </Button>
                    {compartments
                      .filter((c) => c.status)
                      .map((c) => (
                        <Button
                          key={c._id}
                          size="lg"
                          type="button"
                          variant={
                            selectedCompartment &&
                            selectedCompartment._id === c._id
                              ? "primary"
                              : "outline-secondary"
                          }
                          onClick={() => {
                            setSelectedCompartment(c);
                          }}
                        >
                          {c.name}
                        </Button>
                      ))}
                  </div>
                </div>
              )}
              <div
                className="tables-flex scrollbar scrollbar-primary"
                id="tablePanel"
              >
                {carts
                  .filter((c) =>
                    selectedCompartment
                      ? c.tableNum >= selectedCompartment.startNum &&
                        c.tableNum <= selectedCompartment.endNum
                      : compartments && compartments.length > 0
                      ? c.tableNum <=
                        compartments[compartments.length - 1].endNum
                      : c.tableNum < 301
                  )
                  .map((c) => (
                    <div key={c.tableNum} id={"tableButton" + c.tableNum}>
                      <TableButtonSmall
                        cartItems={c.cartItems}
                        cart={c}
                        isSelected={c.tableNum === tableTemp}
                        keyy={c.tableNum}
                        tableNum={c.tableNum}
                        tableMinWitdh={"76px"}
                        tableTemp={tableTemp}
                        setTableTemp={setTableTemp}
                        ctxDispatch={ctxDispatch}
                      ></TableButtonSmall>
                    </div>
                  ))}
              </div>
            </div>
          )}
          {categories && categories.length > 0 && (
            <CategoryTouchList
              resetToHead={resetToHead}
              categories={filteredCategories}
              categories2={categories2}
              isTabletOrMobile={isTabletOrMobile}
              setIsMostUsedProductsSelected={setIsMostUsedProductsSelected}
              isMostUsedProductsSelected={isMostUsedProductsSelected}
            ></CategoryTouchList>
          )}

          <ProductsListTouch
            showNumberPad={showNumberPadForProductsList}
            setShowNumberPad={setShowNumberPadForProductsList}
            showAddCard={showAddCard}
            setShowAddCard={setShowAddCard}
            setNumberPadNumberSelectionHandler={
              setNumberPadNumberSelectionHandlerForProductList
            }
            isTabletOrMobile={isTabletOrMobile}
            products={filteredProducts}
            tableNum={tableTemp}
            features={features}
            feature={feature}
            product={product}
            setFeature={setFeature}
            setFeatures={setFeatures}
            setProduct={setProduct}
            setQueryByName={setQueryByName}
            setIsSaveProduct={setIsSaveProduct}
            setIsVisible={setIsVisible}
            isVisible={isVisible}
            isCustomerOrder={showCustomerOrders}
          ></ProductsListTouch>

          <CartScreenTouch
            tableTemp={tableTemp}
            isCustomerOrder={showCustomerOrders}
            height={"calc(100vh - 2rem)"}
          ></CartScreenTouch>
        </div>
      </div>

      <Modal
        centered
        size="sm"
        show={showEnterDescription}
        onHide={() => setShowEnterDescription(false)}
        onShow={() => descriptionRef.current.focus()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Açıklama</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup>
            <FormControl
              type="text"
              value={description}
              ref={descriptionRef}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              placeholder="Açıklama ..."
            ></FormControl>
            <Button
              variant="outline-primary"
              onClick={() => {
                setDescription("");
              }}
            >
              Temizle
            </Button>
          </InputGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="border-primary text-primary"
            variant="light"
            onClick={() => {
              handleDescriptionChange();
            }}
          >
            Kaydet
          </Button>
          <Button
            className="border-danger text-danger"
            variant="light"
            onClick={() => setShowEnterDescription(false)}
          >
            İptal
          </Button>
        </Modal.Footer>
      </Modal>

      <TableExchange
        carts={carts}
        show={showExchangeTable}
        setShow={setShowExchangeTable}
        changeThisTableNum={tableTemp}
      />

      <NumberPad
        numberPadNumber={numberPadNumber}
        setNumberPadNumber={setNumberPadNumber}
        showNumberPad={showNumberPad}
        setShowNumberPad={setShowNumberPad}
        setNumberPadSelectionHandler={setNumberPadNumberSelectionHandler}
        errorMessage={
          `Masa numarasi ` +
          (compartments && compartments.length > 0
            ? compartments[compartments.length - 1].endNum
            : 300) +
          `'den büyük olamaz!`
        }
        errorLimit={
          compartments && compartments.length > 0
            ? compartments[compartments.length - 1].endNum
            : 300
        }
        headerMessage={"Masa Numarası:"}
      ></NumberPad>
    </div>
  );
}
